export default {
    // api: 'https://api.martendenheijer.nl/data-service/v4'
    // api: 'https://data-service-v4.herokuapp.com'
    api: 'http://192.168.1.128:3003'
}



// WEBPACK FOOTER //
// ./src/config/index.js